import {
  arrayBuilderItemSubsequentPageTitleUI,
  currentOrPastMonthYearDateUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import { HideDefaultDateHint } from '../../../../all-claims/pages/disabilityConditions/shared/conditionDateField';
import { vaTreatmentFacilityItemSchema } from '../../../schema';

const { treatmentDateRange } = vaTreatmentFacilityItemSchema.properties;

export default {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      ({ formData }) => `Treatment dates at ${formData?.treatmentCenterName}`,
    ),
    treatmentDateRange: {
      from: {
        ...currentOrPastMonthYearDateUI({
          title: 'When did you first visit this facility?',
          hint: 'Select a month and enter 4 digits for the year. You can give an estimate for these dates, if needed.',
        }),
        'ui:description': HideDefaultDateHint,
      },
    },
  },
  schema: {
    type: 'object',
    properties: {
      treatmentDateRange,
    },
  },
};
